'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalyticsPageView } from '../components/PageView/Context';
import { getCleanLocationHref } from '../lib/urlUtils';
import { useAnalytics } from './useAnalytics';
export type PageActionProps = {
  actionInput?: string | null;
  actionName?: string | null;
  actionSection?: string;
  actionType?: string;
  activityId?: string;
  destinationURL?: string;
  impressionSection?: string;
  impressionPosition?: number;
  parentActivityId?: string;
  targetPageURL?: string;
  additionalAttributes?: object;
  pageBranchName?: string | null;
};
export type PageActionPayload = {
  action_input: string | null | undefined;
  action_name: string | null | undefined;
  action_section: string | undefined;
  action_type: string | undefined;
  activity_id: string | undefined;
  destination_url: string | undefined;
  parent_activity_id: string | undefined;
  action_location_url: string | undefined;
  target_page_url: string | undefined;
  deployable_name: string | undefined;
  deployable_version: string | undefined;
  impression_page_name: string | undefined;
  impression_page_url: string | undefined;
  impression_pageview_id: string | undefined;
  impression_section: string | undefined;
  impression_position: number | undefined;
  traditional_device_id: string | undefined;
  additional_attributes: object | undefined;
  page_branch_name: string | null | undefined;
};
export const usePageAction = t0 => {
  const $ = _c(24);
  const {
    actionInput,
    actionName,
    actionSection,
    actionType,
    activityId,
    destinationURL,
    impressionSection,
    impressionPosition,
    parentActivityId,
    targetPageURL,
    pageBranchName,
    additionalAttributes
  } = t0;
  const {
    analytics,
    deployableName,
    deployableVersion,
    deviceId,
    gitSha
  } = useAnalytics();
  const {
    pageViewId,
    pageName
  } = useAnalyticsPageView();
  const isClient = typeof window !== "undefined";
  const t1 = pageName || (isClient ? window.location.pathname : undefined);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isClient ? getCleanLocationHref() : undefined;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== actionInput || $[2] !== actionName || $[3] !== actionSection || $[4] !== actionType || $[5] !== activityId || $[6] !== additionalAttributes || $[7] !== deployableName || $[8] !== deployableVersion || $[9] !== destinationURL || $[10] !== deviceId || $[11] !== impressionPosition || $[12] !== impressionSection || $[13] !== pageBranchName || $[14] !== pageViewId || $[15] !== parentActivityId || $[16] !== t1 || $[17] !== targetPageURL) {
    t3 = {
      action_input: actionInput,
      action_name: actionName,
      action_section: actionSection,
      action_type: actionType,
      activity_id: activityId,
      destination_url: destinationURL,
      parent_activity_id: parentActivityId,
      action_location_url: isClient ? window.location.href : undefined,
      target_page_url: targetPageURL,
      deployable_name: deployableName,
      deployable_version: deployableVersion,
      impression_page_name: t1,
      impression_page_url: t2,
      impression_pageview_id: pageViewId,
      impression_section: impressionSection,
      impression_position: impressionPosition,
      traditional_device_id: deviceId,
      page_branch_name: pageBranchName,
      additional_attributes: additionalAttributes
    };
    $[1] = actionInput;
    $[2] = actionName;
    $[3] = actionSection;
    $[4] = actionType;
    $[5] = activityId;
    $[6] = additionalAttributes;
    $[7] = deployableName;
    $[8] = deployableVersion;
    $[9] = destinationURL;
    $[10] = deviceId;
    $[11] = impressionPosition;
    $[12] = impressionSection;
    $[13] = pageBranchName;
    $[14] = pageViewId;
    $[15] = parentActivityId;
    $[16] = t1;
    $[17] = targetPageURL;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  const segmentProps = t3;
  let t4;
  if ($[19] !== analytics || $[20] !== deployableName || $[21] !== gitSha || $[22] !== segmentProps) {
    t4 = (overrideProps, callback) => analytics && void analytics.track("Page Action", {
      ...segmentProps,
      ...overrideProps
    }, {
      context: {
        app: {
          name: deployableName,
          version: gitSha
        }
      }
    })?.finally(() => {
      callback?.();
    });
    $[19] = analytics;
    $[20] = deployableName;
    $[21] = gitSha;
    $[22] = segmentProps;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
};
export type PageActionFireFn = ReturnType<typeof usePageAction>;